(function(){
    'use strict';

    angular.module('homeModule', [])
        .controller('homeCon', ['APRO_BME_URL', homeController]);

    function homeController(APRO_BME_URL){
        window.location = APRO_BME_URL;
    }
})();



// WEBPACK FOOTER //
// ./app/controllers/homeController.js